import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import ShippingDetailsTab from './Freight/ShippingDetailsTab';
import RoutingTab from './Freight/RoutingTab';
import { useDispatch, useSelector } from 'react-redux';
import { getJobOrderAirlineList, getJobOrderAirportList, getJobOrderCurrencyList, getJobOrderCustomerList, getJobOrderFreightDetails, getJobOrderIncotermList, getJobOrderPortList, getJobOrderSeaportList, getJobOrderShiplineList } from '../../../../../Redux/action/Joborder/JoborderAction';
import axios from 'axios';
import { adminMainUrl } from '../../../../../Config';
import { toast } from 'react-toastify';
import { useFormik } from 'formik';
import Beatloader from '../../../../../Common/Loaders/Beatloader';
import InputTextJSX from './InputTextJSX';
import { customStyles } from '../../../../../HelperFunctions';
import { getFFAirExpConsigneeBranch, getFFAirExpConsigneeBranchBank, getFFAirExpOrganisation, getFFAirExpShipperBranch, getFFAirExpShipperBranchBank } from '../../../../../Redux/action/FreightForwarding/Console/FFAirExpAction';
import TextAreaJSX from './TextAreaJSX';
import InputDateJSX from './InputDateJSX';
import SelectReactJSX from './SelectReactJSX';




const FreightAirTab = ({ token, user_id, b64id, transmode, iataAgentOptions }) => {


    const dispatch = useDispatch();
    const [showLoader, setShowLoader] = useState(true);
    const [disableSubmit, setDisableSubmit] = useState(false);



    useEffect(() => {
        if (token && user_id) {
            dispatch(getJobOrderShiplineList());
            dispatch(getJobOrderSeaportList());
            dispatch(getJobOrderAirportList());
            dispatch(getJobOrderPortList());
            dispatch(getJobOrderAirlineList());
            dispatch(getJobOrderCustomerList(token, user_id));
            dispatch(getJobOrderIncotermList());
            dispatch(getJobOrderCurrencyList());
            dispatch(getFFAirExpOrganisation(token, user_id));


            if (b64id) {
                let id = atob(b64id);
                if (id) {
                    dispatch(getJobOrderFreightDetails(token, user_id, id));
                }
            }
        }
    }, [token, user_id, b64id]);


    const refreshFreightData = () => {
        if (token && user_id && b64id) {
            let id = atob(b64id);
            if (id) {
                dispatch(getJobOrderFreightDetails(token, user_id, id));
            }
        }
    }

    let {
        loadingJobOrderFreightDetail,
        JobOrderFreightDetailError,
        JobOrderFreightDetail,


        //list job order airline
        loadingJobOrderAirlineList,
        JobOrderAirlineList,
        JobOrderAirlineListError,

        //list job order shipline
        loadingJobOrderShiplineList,
        JobOrderShiplineList,
        JobOrderShiplineListError,

        //list job order port
        loadingJobOrderPortList,
        JobOrderPortList,
        JobOrderPortListError,

        //list job order airport
        loadingJobOrderAirportList,
        JobOrderAirportList,
        JobOrderAirportListError,

        //list job order seaport
        loadingJobOrderSeaportList,
        JobOrderSeaportList,
        JobOrderSeaportListError,

        //list job order customers
        loadingJobOrderCustomerList,
        JobOrderCustomerList,
        JobOrderCustomerListError,

        //list incoterms
        loadingJobOrderIncotermList,
        JobOrderIncotermListError,
        JobOrderIncotermList,

        //currency
        loadingJobOrderCurrencyList,
        JobOrderCurrencyListError,
        JobOrderCurrencyList,

    } = useSelector(state => state?.JoborderReducer);



    const {
        //organisation list
        loadingFFAirExpOrganisationList,
        FFAirExpOrganisationList,
        FFAirExpOrganisationListError,

        //organisation shipper branch list
        loadingFFAirExpShipperBranchList,
        FFAirExpShipperBranchList,
        FFAirExpShipperBranchListError,

        //organisation consignee branch list
        loadingFFAirExpConsigneeBranchList,
        FFAirExpConsigneeBranchList,
        FFAirExpConsigneeBranchListError,

        //organisatoin shipper branch bank list
        loadingFFAirExpShipperBranchBankList,
        FFAirExpShipperBranchBankList,
        FFAirExpShipperBranchBankListError,

        //organisatoin consignee branch bank list
        loadingFFAirExpConsigneeBranchBankList,
        FFAirExpConsigneeBranchBankList,
        FFAirExpConsigneeBranchBankListError,

    } = useSelector(state => state?.FFAirExpReducer);




    const [currencyOptions, setCurrencyOptions] = useState([]);
    useEffect(() => {
        if (JobOrderCurrencyList) {
            let arr = [];
            JobOrderCurrencyList.map(val => arr.push({ value: val.id, label: `${val.currency}` }));
            setCurrencyOptions(arr);
        }
    }, [JobOrderCurrencyList]);

    const [organisationOptions, setOrganisationOptions] = useState([]);
    useEffect(() => {
        if (FFAirExpOrganisationList) {
            let arr = [];
            FFAirExpOrganisationList.map(val => arr.push({ value: val.id, label: `${val.name} (${val.customerType})`, entity: val.entity_type ? JSON.parse(val.entity_type) : [] }));
            setOrganisationOptions(arr);
        }
    }, [FFAirExpOrganisationList]);

    const [airlineOptions, setAirlineOptions] = useState([]);
    useEffect(() => {
        if (JobOrderAirlineList) {
            let arr = [];
            JobOrderAirlineList.map(v => { arr.push({ value: v.id, label: v.name }) });
            setAirlineOptions(arr);
        }
    }, [JobOrderAirlineList]);

    const [shiplineOptions, setShiplineOptions] = useState([]);
    useEffect(() => {
        if (JobOrderShiplineList) {
            let arr = [];
            JobOrderShiplineList.map(v => { arr.push({ value: v.id, label: v.name }) });
            setShiplineOptions(arr);
        }
    }, [JobOrderShiplineList]);

    const [portOptions, setPortOptions] = useState([]);
    useEffect(() => {
        if (JobOrderPortList) {
            let arr = [];
            JobOrderPortList.map(v => { arr.push({ value: v.id, label: v.name }) });
            setPortOptions(arr);
        }
    }, [JobOrderPortList]);

    const [airportOptions, setAirPortOptions] = useState([]);
    useEffect(() => {
        if (JobOrderAirportList) {
            let arr = [];
            JobOrderAirportList.map(v => { arr.push({ value: v.id, label: v.name }) });
            setAirPortOptions(arr);
        }
    }, [JobOrderAirportList]);



    let [shipperOrganisationOptions, setShipperOrganisationOptions] = useState([]);
    let [consigneeOrganisationOptions, setConsigneeOrganisationOptions] = useState([]);

    let [shipperBranchOptions, setShipperBranchOptions] = useState([]);
    let [consigneeBranchOptions, setConsigneeBranchOptions] = useState([]);

    let [shipperBankOptions, setShipperBankOptions] = useState([]);
    let [consigneeBankOptions, setConsigneeBankOptions] = useState([]);

    useEffect(() => {
        // console.log(FFAirExpShipperBranchList);
        if (FFAirExpShipperBranchList) {
            let arr = [];
            FFAirExpShipperBranchList.map(val => arr.push({ value: val.id, label: val.branch_name }));
            setShipperBranchOptions(arr);
        }
    }, [FFAirExpShipperBranchList]);

    useEffect(() => {
        if (FFAirExpShipperBranchBankList) {
            let arr = [];
            FFAirExpShipperBranchBankList.map(val => arr.push({ value: val.id, label: val.entity_name }));
            setShipperBankOptions(arr);
        }
    }, [FFAirExpShipperBranchBankList]);

    useEffect(() => {
        if (FFAirExpConsigneeBranchList) {
            let arr = [];
            FFAirExpConsigneeBranchList.map(val => arr.push({ value: val.id, label: val.branch_name }));
            setConsigneeBranchOptions(arr);
        }
    }, [FFAirExpConsigneeBranchList]);

    useEffect(() => {
        if (FFAirExpConsigneeBranchBankList) {
            let arr = [];
            FFAirExpConsigneeBranchBankList.map(val => arr.push({ value: val.id, label: val.entity_name }));
            setConsigneeBankOptions(arr);
        }
    }, [FFAirExpConsigneeBranchBankList]);

    useEffect(() => {
        if (organisationOptions) {
            let shipperArr = [];
            let consigneeArr = [];

            organisationOptions.map(object => {
                if (object.entity && object.entity.includes("shipper")) {
                    shipperArr.push(object);
                }
                if (object.entity && object.entity.includes("consignee")) {
                    consigneeArr.push(object);
                }
            });
            setShipperOrganisationOptions(shipperArr);
            setConsigneeOrganisationOptions(consigneeArr);
        }
    }, [organisationOptions]);


    const handleShipperBranch = (shipper_id) => {
        if (shipper_id && token && user_id) {
            dispatch(getFFAirExpShipperBranch(token, user_id, shipper_id));
        }
    };
    const handleShipperBanks = (branch_id) => {
        if (branch_id && token && user_id) {
            dispatch(getFFAirExpShipperBranchBank(token, user_id, branch_id));
        }
    };

    const handleConsigneeBranch = (consignee_id) => {
        if (consignee_id && token && user_id) {
            dispatch(getFFAirExpConsigneeBranch(token, user_id, consignee_id));
        }
    };
    const handleConsigneeBanks = (branch_id) => {
        if (branch_id && token && user_id) {
            dispatch(getFFAirExpConsigneeBranchBank(token, user_id, branch_id));
        }
    };



    const formik = useFormik({
        initialValues: {
            shipper_id: 0,
            shipper_branch_id: 0,
            shipper_branch_bank_account_id: 0,
            consignee_id: 0,
            consignee_branch_id: 0,
            consignee_branch_bank_account_id: 0,
            issuing_carrier_agent_id: 0,
            // issuing_carrier_agent_name: "",
            // issuing_carrier_agent_address: "",
            // agent_iata_code: "",
            // agent_account_number: "",
            airport_of_departure_id: 0,
            airport_of_departure_name: "",
            airport_of_destination_id: 0,
            airport_of_destination_name: "",
            to_one: "",
            by_first_carrier: "",
            to_two: "",
            by_one: "",
            to_three: "",
            by_two: "",
            flight_no_one: "",
            flight_date_one: "",
            flight_no_two: "",
            flight_date_two: "",
            cto: "",
            currency: "",
            chgs_code: "",
            wt_val: "",
            other: "",
            declared_value_for_carriage: "",
            declared_value_for_customs: "",
            amount_of_insurance: "",
            handling_info: "",
            port_of_loading: 0,
            port_of_discharge: 0,
            place_of_acceptance: "",
            place_of_delivery: "",
            vessel_and_voyage_no: "",
            freight_term: "",
            freight_payable_at: "",
            number_of_original_mdt: "",
            place_of_issue: "",
            place_of_date: "",
            notify_address: "",
            notify_email_address: "",
            delivery_of_goods_apply_to_address: "",
            delivery_of_goods_apply_to_email: "",
            delivery_of_goods_apply_to_tax_id: 0,
            delivery_of_goods_apply_to_zc: "",
        },
        onSubmit: (values) => {
            // console.log(values);
            setDisableSubmit(true);
            try {
                let config = {
                    headers: {
                        'auth-token': token,
                        'user_id': user_id
                    }
                };
                values.job_order_id = atob(b64id);
                axios.post(`${adminMainUrl}/api/jobOrder/freight/add-update`, values, config)
                    .then(response => {
                        if (response.status == 200) {
                            toast.success(response?.data?.msg);
                            setDisableSubmit(false);
                            refreshFreightData();
                        } else {
                            toast.error(response?.data?.msg);
                            setDisableSubmit(false);
                        }
                    }).catch(error => {
                        console.log(error);
                        let msg = "Internal Server Error!"
                        if (error.response) {
                            if (error.response.data) {
                                if (error.response.data.msg) {
                                    msg = error.response.data.msg;
                                }
                            }
                        }
                        toast.error(msg);
                        setDisableSubmit(false);
                    })
            } catch (error) {
                console.log(error.message);
                toast.error(error.message);
                setDisableSubmit(false);
            }
        }
    });

    function convertTimestampToDate(timestamp) {
        const date = new Date(timestamp);
        return date.toISOString().split('T')[0];
    }

    useEffect(() => {
        if (loadingJobOrderFreightDetail) {
            setShowLoader(true)
        } else {
            setShowLoader(false)
        };

        if (JobOrderFreightDetail) {

            formik.setFieldValue("shipper_id", JobOrderFreightDetail.shipper_id);

            if (JobOrderFreightDetail.shipper_id) {
                dispatch(getFFAirExpShipperBranch(token, user_id, JobOrderFreightDetail.shipper_id));
            }

            formik.setFieldValue("shipper_branch_id", JobOrderFreightDetail.shipper_branch_id);
            if (JobOrderFreightDetail.shipper_branch_id) {
                dispatch(getFFAirExpShipperBranchBank(token, user_id, JobOrderFreightDetail.shipper_branch_id));
            }

            formik.setFieldValue("shipper_branch_bank_account_id", JobOrderFreightDetail.shipper_branch_bank_account_id);

            formik.setFieldValue("consignee_id", JobOrderFreightDetail.consignee_id);
            if (JobOrderFreightDetail.consignee_id) {
                dispatch(getFFAirExpConsigneeBranch(token, user_id, JobOrderFreightDetail.consignee_id));
            }

            formik.setFieldValue("consignee_branch_id", JobOrderFreightDetail.consignee_branch_id);
            if (JobOrderFreightDetail.consignee_branch_id) {
                dispatch(getFFAirExpConsigneeBranchBank(token, user_id, JobOrderFreightDetail.consignee_branch_id));
            }

            formik.setFieldValue("consignee_branch_bank_account_id", JobOrderFreightDetail.consignee_branch_bank_account_id);

            formik.setFieldValue("issuing_carrier_agent_id", JobOrderFreightDetail.issuing_carrier_agent_id ?? 0);
            // formik.setFieldValue("issuing_carrier_agent_name", JobOrderFreightDetail.issuing_carrier_agent_name);
            // formik.setFieldValue("issuing_carrier_agent_address", JobOrderFreightDetail.issuing_carrier_agent_address);
            // formik.setFieldValue("agent_iata_code", JobOrderFreightDetail.agent_iata_code);
            // formik.setFieldValue("agent_account_number", JobOrderFreightDetail.agent_account_number);
            formik.setFieldValue("airport_of_departure_id", JobOrderFreightDetail.airport_of_departure_id);
            formik.setFieldValue("airport_of_departure_name", JobOrderFreightDetail.airport_of_departure_name);

            formik.setFieldValue("airport_of_destination_id", JobOrderFreightDetail.airport_of_destination_id);
            formik.setFieldValue("airport_of_destination_name", JobOrderFreightDetail.airport_of_destination_name);

            formik.setFieldValue("to_one", JobOrderFreightDetail.to_one);
            formik.setFieldValue("by_first_carrier", JobOrderFreightDetail.by_first_carrier);
            formik.setFieldValue("to_two", JobOrderFreightDetail.to_two);
            formik.setFieldValue("by_one", JobOrderFreightDetail.by_one);
            formik.setFieldValue("to_three", JobOrderFreightDetail.to_three);
            formik.setFieldValue("by_two", JobOrderFreightDetail.by_two);
            formik.setFieldValue("flight_no_one", JobOrderFreightDetail.flight_no_one);
            formik.setFieldValue("flight_date_one", JobOrderFreightDetail.flight_date_one);
            formik.setFieldValue("flight_no_two", JobOrderFreightDetail.flight_no_two);
            formik.setFieldValue("flight_date_two", JobOrderFreightDetail.flight_date_two);
            formik.setFieldValue("cto", JobOrderFreightDetail.cto);
            formik.setFieldValue("currency", JobOrderFreightDetail.currency);
            formik.setFieldValue("chgs_code", JobOrderFreightDetail.chgs_code);
            formik.setFieldValue("wt_val", JobOrderFreightDetail.wt_val);
            formik.setFieldValue("other", JobOrderFreightDetail.other);
            formik.setFieldValue("declared_value_for_carriage", JobOrderFreightDetail.declared_value_for_carriage);
            formik.setFieldValue("declared_value_for_customs", JobOrderFreightDetail.declared_value_for_customs);
            formik.setFieldValue("amount_of_insurance", JobOrderFreightDetail.amount_of_insurance);
            formik.setFieldValue("handling_info", JobOrderFreightDetail.handling_info);
            formik.setFieldValue("port_of_loading", JobOrderFreightDetail.port_of_loading);

            formik.setFieldValue("port_of_discharge", JobOrderFreightDetail.port_of_discharge);

            formik.setFieldValue("place_of_acceptance", JobOrderFreightDetail.place_of_acceptance);
            formik.setFieldValue("place_of_delivery", JobOrderFreightDetail.place_of_delivery);
            formik.setFieldValue("vessel_and_voyage_no", JobOrderFreightDetail.vessel_and_voyage_no);
            formik.setFieldValue("freight_term", JobOrderFreightDetail.freight_term);
            formik.setFieldValue("freight_payable_at", JobOrderFreightDetail.freight_payable_at);
            formik.setFieldValue("number_of_original_mdt", JobOrderFreightDetail.number_of_original_mdt);
            formik.setFieldValue("place_of_issue", JobOrderFreightDetail.place_of_issue);
            formik.setFieldValue("place_of_date", JobOrderFreightDetail.place_of_date);
            formik.setFieldValue("notify_address", JobOrderFreightDetail.notify_address);
            formik.setFieldValue("notify_email_address", JobOrderFreightDetail.notify_email_address);
            formik.setFieldValue("delivery_of_goods_apply_to_address", JobOrderFreightDetail.delivery_of_goods_apply_to_address);
            formik.setFieldValue("delivery_of_goods_apply_to_email", JobOrderFreightDetail.delivery_of_goods_apply_to_email);
            formik.setFieldValue("delivery_of_goods_apply_to_tax_id", JobOrderFreightDetail.delivery_of_goods_apply_to_tax_id);

            formik.setFieldValue("delivery_of_goods_apply_to_zc", JobOrderFreightDetail.delivery_of_goods_apply_to_zc);

        }

    }, [loadingJobOrderFreightDetail, JobOrderFreightDetailError, JobOrderFreightDetail,]);

    return (
        <>
            {
                showLoader ?
                    <Beatloader />
                    :
                    <>
                        <div className="row-gap-2">
                            <ul className="nav nav-pills mb-3 custom-tabs gap-0" id="pills-tab" role="tablist">
                                <li className="nav-item" role="presentation">
                                    <button className="nav-link active" id="Freight-shipping-tab" data-bs-toggle="pill" data-bs-target="#Freight-shipping" type="button" role="tab" aria-controls="Freight-shipping" aria-selected="true">Shipping Details</button>
                                </li>

                            </ul>
                            <div className="tab-content" id="pills-tabContent">
                                <div className="tab-pane fade show active" id="Freight-shipping" role="tabpanel" aria-labelledby="Freight-shipping-tab">
                                    <form onSubmit={formik.handleSubmit}>
                                        <div className="row">
                                            {/* <h3 className='mt-2'>HAWB</h3> */}
                                            <h4 className='mt-2'>Party Details</h4>

                                            <div className="col-md-6 mt-2">
                                                <div className='ms-2'>
                                                    <label htmlFor="" className='form-label  mb-0'>
                                                        Shipper
                                                    </label>
                                                    <div className="icon-forms mb-3 mb-sm-0">
                                                        <Select
                                                            className='custom-selector'
                                                            options={shipperOrganisationOptions}
                                                            styles={customStyles}
                                                            name="shipper_id"
                                                            onChange={option => {
                                                                formik.setFieldValue("shipper_branch_id", "");
                                                                formik.setFieldValue("shipper_branch_bank_account_id", "");
                                                                setShipperBranchOptions([]);
                                                                setShipperBankOptions([]);
                                                                formik.setFieldValue('shipper_id', option.value);
                                                                handleShipperBranch(option.value);
                                                            }}
                                                            value={shipperOrganisationOptions.find(option => option.value === formik.values.shipper_id || null)}
                                                            // isLoading={loadingOrganisation}
                                                            isDisabled={false}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6 mt-2">
                                                <div className='ms-2'>
                                                    <label htmlFor="" className='form-label  mb-0'>
                                                        Shipper Branch
                                                    </label>
                                                    <div className="icon-forms mb-3 mb-sm-0">
                                                        <Select
                                                            className='custom-selector'
                                                            options={shipperBranchOptions}
                                                            styles={customStyles}
                                                            name="shipper_branch_id"
                                                            onChange={option => {
                                                                formik.setFieldValue("shipper_branch_bank_account_id", "");
                                                                setShipperBankOptions([]);
                                                                formik.setFieldValue('shipper_branch_id', option.value);
                                                                handleShipperBanks(option.value);
                                                            }}
                                                            value={shipperBranchOptions.find(option => option.value === formik.values.shipper_branch_id || null)}
                                                        // isLoading={loadingFFAirExpShipperBranchList}
                                                        // isDisabled={false}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6 mt-2">
                                                <div className='ms-2'>
                                                    <label htmlFor="" className='form-label  mb-0'>
                                                        Shipper Branch Account No.
                                                    </label>
                                                    <div className="icon-forms mb-3 mb-sm-0">
                                                        <Select
                                                            className='custom-selector'
                                                            options={shipperBankOptions}
                                                            styles={customStyles}
                                                            name="shipper_branch_bank_account_id"
                                                            onChange={option => {
                                                                formik.setFieldValue('shipper_branch_bank_account_id', option.value);
                                                            }}
                                                            value={shipperBankOptions.find(option => option.value === formik.values.shipper_branch_bank_account_id || null)}
                                                        // isLoading={loadingFFAirExpConsigneeBranchBankList}
                                                        // isDisabled={false}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6"></div>
                                            <div className="col-md-6 mt-2">
                                                <div className='ms-2'>
                                                    <label htmlFor="" className='form-label  mb-0'>
                                                        Consignee
                                                    </label>
                                                    <div className="icon-forms mb-3 mb-sm-0">
                                                        <Select
                                                            className='custom-selector'
                                                            options={consigneeOrganisationOptions}
                                                            styles={customStyles}
                                                            name="quotation_id"
                                                            onChange={option => {
                                                                setConsigneeBranchOptions([]);
                                                                setConsigneeBankOptions([]);
                                                                formik.setFieldValue("consignee_branch_id", "");
                                                                formik.setFieldValue("consignee_branch_bank_account_id", "");
                                                                formik.setFieldValue('consignee_id', option.value);
                                                                handleConsigneeBranch(option.value);
                                                            }}
                                                            value={consigneeOrganisationOptions.find(option => option.value === formik.values.consignee_id || null)}
                                                            // isLoading={loadingOrganisation}
                                                            isDisabled={false}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6 mt-2">
                                                <div className='ms-2'>
                                                    <label htmlFor="" className='form-label  mb-0'>
                                                        Consignee Branch
                                                    </label>
                                                    <div className="icon-forms mb-3 mb-sm-0">
                                                        <Select
                                                            className='custom-selector'
                                                            options={consigneeBranchOptions}
                                                            styles={customStyles}
                                                            name="consignee_branch_id"
                                                            onChange={option => {
                                                                setConsigneeBankOptions([]);
                                                                formik.setFieldValue("consignee_branch_bank_account_id", "");
                                                                formik.setFieldValue('consignee_branch_id', option.value);
                                                                handleConsigneeBanks(option.value);
                                                            }}
                                                            value={consigneeBranchOptions.find(option => option.value === formik.values.consignee_branch_id || null)}
                                                            // isLoading={loadingFFAirExpShipperBranchList}
                                                            isDisabled={false}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6 mt-2">
                                                <div className='ms-2'>
                                                    <label htmlFor="" className='form-label  mb-0'>
                                                        Consignee Branch Account No.
                                                    </label>
                                                    <div className="icon-forms mb-3 mb-sm-0">
                                                        <Select
                                                            className='custom-selector'
                                                            options={consigneeBankOptions}
                                                            styles={customStyles}
                                                            name="consignee_branch_bank_account_id"
                                                            onChange={option => {
                                                                formik.setFieldValue('consignee_branch_bank_account_id', option.value);
                                                            }}
                                                            value={consigneeBankOptions.find(option => option.value === formik.values.consignee_branch_bank_account_id || null)}
                                                        // isLoading={loadingFFAirExpConsigneeBranchBankList}
                                                        // isDisabled={false}  
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-6 mt-2">
                                                <div className='ms-2'>
                                                    <label htmlFor="" className='form-label  mb-0'>
                                                        IATA Agent
                                                    </label>
                                                    <div className="icon-forms mb-3 mb-sm-0">
                                                        <Select
                                                            className='custom-selector'
                                                            options={iataAgentOptions}
                                                            styles={customStyles}
                                                            name="issuing_carrier_agent_id"
                                                            onChange={option => {
                                                                formik.setFieldValue('issuing_carrier_agent_id', option.value);
                                                            }}
                                                            value={iataAgentOptions.find(option => option.value === formik.values.issuing_carrier_agent_id || null)}
                                                        // isLoading={loadingFFAirExpConsigneeBranchBankList}
                                                        // isDisabled={false}  
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            {/* <div className="col-md-6"></div> */}

                                            {/* Agent Name */}
                                            {/* <InputTextJSX labelText={"Agent Name"} nameValue={"issuing_carrier_agent_name"} value={formik.values.issuing_carrier_agent_name} onChange={formik.handleChange} maxLength={100} />
                                            <InputTextJSX labelText={"Agent Address"} nameValue={"issuing_carrier_agent_address"} value={formik.values.issuing_carrier_agent_address} onChange={formik.handleChange} />
                                            <InputTextJSX labelText={"Agent IATA Code"} nameValue={"agent_iata_code"} value={formik.values.agent_iata_code} onChange={formik.handleChange} maxLength={10} />
                                            <InputTextJSX labelText={"Agent Account No."} nameValue={"agent_account_number"} value={formik.values.agent_account_number} onChange={formik.handleChange} maxLength={30} /> */}


                                            <h4 className='mt-2'>Flight Booking/ Routing</h4>

                                            <div className="col-md-6 mt-2">
                                                <div className='ms-2'>
                                                    <label htmlFor="" className='form-label  mb-0'>
                                                        Airport of Departure
                                                    </label>
                                                    <div className="icon-forms mb-3 mb-sm-0">
                                                        <Select
                                                            className='custom-selector'
                                                            options={airportOptions}
                                                            styles={customStyles}
                                                            name="airport_of_departure_id"
                                                            onChange={(option) => {
                                                                formik.setFieldValue("airport_of_departure_id", option.value)
                                                                formik.setFieldValue("airport_of_departure_name", option.label)
                                                            }}
                                                            value={airportOptions.find(option => option.value === formik.values.airport_of_departure_id || null)}
                                                        // isLoading={loadingAirport}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6 mt-2">
                                                <div className='ms-2'>
                                                    <label htmlFor="" className='form-label  mb-0'>
                                                        Airport of Destination
                                                    </label>
                                                    <div className="icon-forms mb-3 mb-sm-0">
                                                        <Select
                                                            className='custom-selector'
                                                            options={airportOptions}
                                                            styles={customStyles}
                                                            name="airport_of_destination_id"
                                                            onChange={(option) => {
                                                                formik.setFieldValue("airport_of_destination_id", option.value)
                                                                formik.setFieldValue("airport_of_destination_name", option.label)
                                                            }}
                                                            value={airportOptions.find(option => option.value === formik.values.airport_of_destination_id || null)}
                                                        // isLoading={loadingAirport}
                                                        />
                                                    </div>
                                                </div>
                                            </div>


                                            <InputTextJSX labelText={"To"} nameValue={"to_one"} value={formik.values.to_one} onChange={formik.handleChange} splithalf={true} maxLength={30} />
                                            <InputTextJSX labelText={"By First Carrier"} nameValue={"by_first_carrier"} value={formik.values.by_first_carrier} onChange={formik.handleChange} splithalf={true} maxLength={30} />
                                            <InputTextJSX labelText={"To"} nameValue={"to_two"} value={formik.values.to_two} onChange={formik.handleChange} splithalf={true} maxLength={30} />
                                            <InputTextJSX labelText={"By"} nameValue={"by_one"} value={formik.values.by_one} onChange={formik.handleChange} splithalf={true} maxLength={30} />
                                            <InputTextJSX labelText={"To"} nameValue={"to_three"} value={formik.values.to_three} onChange={formik.handleChange} splithalf={true} maxLength={30} />
                                            <InputTextJSX labelText={"By"} nameValue={"by_two"} value={formik.values.by_two} onChange={formik.handleChange} splithalf={true} maxLength={30} />

                                            <div className={`col-md-6 mt-2`}>
                                                <div className='ms-2'>
                                                    <label htmlFor="" className='form-label  mb-0'>
                                                        CTO
                                                    </label>
                                                    <div className="icon-forms mb-3 mb-sm-0">
                                                        <select
                                                            className="form-control form-control-sm"
                                                            id="cto"
                                                            name="cto"
                                                            value={formik.values.cto}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                        >
                                                            <option value="" disabled>-Select an option-</option>
                                                            <option value="DCSC">DCSC</option>
                                                            <option value="CELEBI">CELEBI</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>

                                            <InputTextJSX labelText={"Flt No 1"} nameValue={"flight_no_one"} value={formik.values.flight_no_one} onChange={formik.handleChange} maxLength={15} />
                                            {/* <InputDateJSX labelText={"Flt Dt 1"} nameValue={"flight_date_one"} value={formik.values.flight_date_one} onChange={formik.handleChange} /> */}
                                            <div className="col-md-6 mt-2">
                                                <div className='ms-2'>
                                                    <label htmlFor="" className='form-label  mb-0'>
                                                        Flt Dt 1
                                                    </label>
                                                    <div className="icon-forms mb-3 mb-sm-0">
                                                        <input
                                                            type="date"
                                                            className="form-control form-control-sm"
                                                            id={"flight_date_one"}
                                                            name={"flight_date_one"}
                                                            value={formik.values.flight_date_one}
                                                            onChange={formik.handleChange}
                                                            min={new Date().toISOString().split("T")[0]}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <InputTextJSX labelText={"Flt No 2"} nameValue={"flight_no_two"} value={formik.values.flight_no_two} onChange={formik.handleChange} maxLength={15} />
                                            {/* <InputDateJSX labelText={"Flt Dt 2"} nameValue={"flight_date_two"} value={formik.values.flight_date_two} onChange={formik.handleChange} /> */}
                                            <div className="col-md-6 mt-2">
                                                <div className='ms-2'>
                                                    <label htmlFor="" className='form-label  mb-0'>
                                                        Flt Dt 2
                                                    </label>
                                                    <div className="icon-forms mb-3 mb-sm-0">
                                                        <input
                                                            type="date"
                                                            className="form-control form-control-sm"
                                                            id={"flight_date_two"}
                                                            name={"flight_date_two"}
                                                            value={formik.values.flight_date_two}
                                                            onChange={formik.handleChange}
                                                            min={new Date().toISOString().split("T")[0]}
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            <h4 className='mt-2'>Charge Declaration</h4>
                                            <SelectReactJSX
                                                labelText={"Currency"}
                                                nameValue={"currency"}
                                                onChange={(option) => { formik.setFieldValue("currency", option.value) }}
                                                options={currencyOptions}
                                                value={currencyOptions.find(option => option.value === formik.values.currency || null)}
                                            // isLoading={loadingCurrency}
                                            />

                                            <div className={`col-md-6 mt-2`}>
                                                <div className='ms-2'>
                                                    <label htmlFor="" className='form-label  mb-0'>
                                                        CHGS CODE
                                                    </label>
                                                    <div className="icon-forms mb-3 mb-sm-0">
                                                        <select
                                                            className="form-control form-control-sm"
                                                            id="chgs_code"
                                                            name="chgs_code"
                                                            value={formik.values.chgs_code}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                        >
                                                            <option value="" disabled>-Select an option-</option>
                                                            <option value="PP">PP</option>
                                                            <option value="PC">PC</option>
                                                            <option value="CP">CP</option>
                                                            <option value="CC">CC</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className={`col-md-6 mt-2`}>
                                                <div className='ms-2'>
                                                    <label htmlFor="" className='form-label  mb-0'>
                                                        Wt/Val(P/C)
                                                    </label>
                                                    <div className="icon-forms mb-3 mb-sm-0">
                                                        <select
                                                            className="form-control form-control-sm"
                                                            id="wt_val"
                                                            name="wt_val"
                                                            value={formik.values.wt_val}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                        >
                                                            <option value="" disabled>-Select an option-</option>
                                                            <option value="P">P</option>
                                                            <option value="C">C</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className={`col-md-6 mt-2`}>
                                                <div className='ms-2'>
                                                    <label htmlFor="" className='form-label  mb-0'>
                                                        Other(P/C)
                                                    </label>
                                                    <div className="icon-forms mb-3 mb-sm-0">
                                                        <select
                                                            className="form-control form-control-sm"
                                                            id="other"
                                                            name="other"
                                                            value={formik.values.other}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                        >
                                                            <option value="" disabled>-Select an option-</option>
                                                            <option value="P">P</option>
                                                            <option value="C">C</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>

                                            <InputTextJSX labelText={"Declared Value for Carriage"} nameValue={"declared_value_for_carriage"} value={formik.values.declared_value_for_carriage} onChange={formik.handleChange} />
                                            <InputTextJSX labelText={"Declared Value for Customs"} nameValue={"declared_value_for_customs"} value={formik.values.declared_value_for_customs} onChange={formik.handleChange} />
                                            <InputTextJSX labelText={"Amount of Insurance"} nameValue={"amount_of_insurance"} value={formik.values.amount_of_insurance} onChange={formik.handleChange} />
                                            <TextAreaJSX labelText="Handeling Info" nameValue="handling_info" value={formik.values.handling_info} onChange={formik.handleChange} maxLength={250} />


                                            {/* <TextAreaJSX labelText="Nature and Quantity" nameValue="nature_and_qty" value={formik.values.nature_and_qty} onChange={formik.handleChange} maxLength={250} /> */}
                                            {/* <TextAreaJSX labelText="Remarks" nameValue="remarks" value={formik.values.remarks} onChange={formik.handleChange} maxLength={250} /> */}



                                        </div>
                                        <div className="row d-flex justify-content-end mt-2">
                                            <div className="col-md-6 d-flex justify-content-end">
                                                <button type="submit" className="btn btn-sm btn-danger" disabled={disableSubmit}>
                                                    {disableSubmit ? <><i className="fas fa-spinner fa-spin"></i> Saving...</> : "Update"}
                                                </button>
                                            </div>
                                        </div>
                                    </form>



                                </div>
                                <div className="tab-pane fade" id="Freight-routing" role="tabpanel" aria-labelledby="Freight-routing-tab">
                                    {/* <ShipperTab />   */}
                                    <RoutingTab />
                                </div>

                            </div>
                        </div>
                    </>
            }
        </>

    )
}

export default FreightAirTab